module.exports = __webpack_public_path__ + "img/acledalogo3.d8553041.png";